import React from "react";
import { dateFormat } from "../../Utils/Global";
import { BASE_URL_REPORTS, BASE_URL_UI } from "../../config";
import GenerateReportTrigger from "../DashboardPage/GenerateReport/GenerateReportTrigger";
import i18n from "../../Utils/i18next";
import { Badge } from "../GeneralComponents/ui";
import { isValidWriteRoles } from "../DashboardPage/RoleStore";
import { useSelector } from "react-redux";
import ReportThumbnail from "../DashboardPage/ReportThumbnail";
import { useDashboardContext } from "../DashboardPage/DashboardContext";
import { hexToRgba } from "../../Utils/Color";

/**
 * Landing page search result list component
 */
const SearchedDashboard = (props) => {
  const { openGenerateReport } = useDashboardContext();
  const isReport = props.data?.type === "report";
  const theme = props.theme;

  const reduxState = useSelector((state) => state);
  const isThemeUrlAvailable = reduxState.UrlParametersReducer.urlUtils.has("theme")
    ? reduxState.UrlParametersReducer.urlUtils.get("theme")
    : false;
  const isThemeAvailable = isThemeUrlAvailable ? `?theme=${isThemeUrlAvailable}` : "";

  const path = isReport
    ? BASE_URL_REPORTS + "/designer/" + props.data.id
    : BASE_URL_UI + "/dashboard/" + props.data.id + isThemeAvailable;

  const details = (
    <div className="detail" style={{ flex: 1, minWidth: 0, display: "flex", flexDirection: "column", justifyContent: "center" }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline", gap: "8px", marginBottom: "4px" }}>
        <p id="resultTitle" style={{ fontWeight: "700", fontSize: "15px", margin: 0, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", color: theme?.textColor || "inherit" }}>
          {props.data.title}
        </p>
        <p id="resultDate" className="creationDate" style={{ fontSize: "11px", opacity: 0.5, margin: 0, whiteSpace: "nowrap", flexShrink: 0, color: theme?.textColor }}>
          {dateFormat(props.data.creationDate, "/")}
        </p>
      </div>
      {props.data.description && (
        <p id="resultDescription" style={{ display: "block", fontSize: "12px", opacity: 0.6, marginBottom: "8px", overflow: "hidden", textOverflow: "ellipsis", display: "-webkit-box", WebkitLineClamp: 2, WebkitBoxOrient: "vertical", lineHeight: "1.4", color: theme?.textColor }}>
          {props.data.description}
        </p>
      )}
      {props.data.labels && props.data.labels.length > 0 ? (
        <div id="resultLabels" className="labels" style={{ display: "flex", flexWrap: "wrap", gap: "6px" }}>
          {props.data.labels.map((l) => (
            <Badge
              key={l.id}
              count={i18n.t(l.displayName)}
              style={{
                backgroundColor: hexToRgba(l.color || "#000000", 0.1),
                color: l.color,
                border: `1px solid ${hexToRgba(l.color || "#000000", 0.1)}`,
                fontSize: "11px",
                fontWeight: "600",
                height: "24px",
                lineHeight: "22px",
                borderRadius: "16px",
                padding: "0 10px",
                boxShadow: "none"
              }}
            />
          ))}
        </div>
      ) : null}
    </div>
  );

  const thumbContainerStyle = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100px",
    height: "100px",
    minWidth: "100px",
    marginRight: "20px",
    border: `1px solid ${hexToRgba(theme?.textColor || "#000000", 0.1)}`,
    borderRadius: "8px",
    background: hexToRgba(theme?.textColor || "#000000", 0.05),
    overflow: "hidden",
    alignSelf: "center",
    boxSizing: "border-box",
    boxShadow: "0 4px 12px rgba(0,0,0,0.03)"
  };

  const content = (
    <>
      <div style={thumbContainerStyle} id="resultThumbnail">
        <ReportThumbnail
          data={props.data}
          title={props.data.title}
          style={{ height: "100%", width: "100%" }}
          theme={{
            backgroundColor: hexToRgba(theme?.textColor || "#000000", 0.05),
            textColor: hexToRgba(theme?.textColor || "#000000", 0.5)
          }}
        />
      </div>
      {details}
    </>
  );

  if (isReport && !isValidWriteRoles()) {
    return (
      <div className="searchedDashboard" onClick={() => openGenerateReport(props.data.id, props.data.isTemplateValid)}>
        {content}
        <div className="action" onClick={(e) => e.preventDefault()}>
          <GenerateReportTrigger
            reportId={props.data.id}
            templateValid={props.data.isTemplateValid}
            innerClass="generate-report"
          >
            <div className="generate-button">
              <i className="fa fa-download"></i>
            </div>
          </GenerateReportTrigger>
        </div>
      </div>
    );
  }

  return (
    <a className="searchedDashboard" href={path} target="_blank" rel="noreferrer">
      {content}
      {isReport ? (
        <div className="action" onClick={(e) => e.preventDefault()}>
          <GenerateReportTrigger
            reportId={props.data.id}
            templateValid={props.data.isTemplateValid}
            innerClass="generate-report"
          >
            <div className="generate-button">
              <i className="fa fa-download"></i>
            </div>
          </GenerateReportTrigger>
        </div>
      ) : null}
    </a>
  );
};

export default SearchedDashboard;
